import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import AppBar from './components/AppBar';
import BoardPage from './components/Board';
import BhagavathaSaptahPage from './components/BhagavathaSaptah';
import CharityPage from './components/Charity';
import EventsPage from './components/Events';
import Footer from './components/Footer';
import HomePage from './components/Home';
import KarkidakaVavuBali from './components/Karkidakavavubali';
import KarkidakaVavuBali2026 from './components/Karkidakavavubali_2026';
import Privacypolicy from './components/Privacypolicy';
import UpdatesPage from './components/Updates';
import InstructionsPage from './components/Instructions';
import { ROUTES } from './Constants';

function App() {
  return (

    <BrowserRouter>
      <AppBar />

      <main className="min-h-screen">
        <Routes>
          <Route path={ROUTES.HOME} element={<HomePage />} />
          <Route path={ROUTES.EVENTS} element={<EventsPage />} />
          <Route path={ROUTES.GALLERY} element={<UpdatesPage />} />
          <Route path={ROUTES.BOARD} element={<BoardPage />} />
          <Route path={ROUTES.KARKIDAKAVAVUBALI} element={<KarkidakaVavuBali />} />
          <Route path={ROUTES.BHAGAVATHA_SAPTAH} element={<BhagavathaSaptahPage />} />
          <Route path={ROUTES.PRIVACYPOLICY} element={<Privacypolicy />} />
          <Route path={ROUTES.CHARITY} element={<CharityPage />} />
          <Route path={ROUTES.INSTRUCTIONS} element={<InstructionsPage />} />
          <Route path={ROUTES.KARKIDAKAVAVUBALI_2026} element={<KarkidakaVavuBali2026 />} />
        </Routes>
      </main>

      <Footer />
    </BrowserRouter>

  );
}

export default App;
